import TimeframesBarChart from './TimeframesBarChart';
import './TimeframesBarChart.scss';
export default TimeframesBarChart;